import { Status as ParticipantStatusApi } from '@wix/ambassador-asa-participant-v1-participant/types';
import { isValidParticipant, ParticipantStatus } from './Participant';
const participantApiStatusToParticipantStatusMap = {
  [ParticipantStatusApi.UNKNOWN]: ParticipantStatus.UNKNOWN,
  [ParticipantStatusApi.PENDING]: ParticipantStatus.PENDING,
  [ParticipantStatusApi.SCHEDULED]: ParticipantStatus.SCHEDULED,
  [ParticipantStatusApi.PAUSED]: ParticipantStatus.PAUSED,
  [ParticipantStatusApi.IN_PROGRESS]: ParticipantStatus.IN_PROGRESS,
  [ParticipantStatusApi.USER_INTERVENTION]: ParticipantStatus.USER_INTERVENTION,
  [ParticipantStatusApi.FAILED_TO_CONTACT]: ParticipantStatus.FAILED_TO_CONTACT,
  [ParticipantStatusApi.INVALID]: ParticipantStatus.INVALID
};
const participantStatusToParticipantStatusApisMap = {
  [ParticipantStatus.UNKNOWN]: ParticipantStatusApi.UNKNOWN,
  [ParticipantStatus.PENDING]: ParticipantStatusApi.PENDING,
  [ParticipantStatus.SCHEDULED]: ParticipantStatusApi.SCHEDULED,
  [ParticipantStatus.PAUSED]: ParticipantStatusApi.PAUSED,
  [ParticipantStatus.IN_PROGRESS]: ParticipantStatusApi.IN_PROGRESS,
  [ParticipantStatus.USER_INTERVENTION]: ParticipantStatusApi.USER_INTERVENTION,
  [ParticipantStatus.FAILED_TO_CONTACT]: ParticipantStatusApi.FAILED_TO_CONTACT,
  [ParticipantStatus.INVALID]: ParticipantStatusApi.INVALID
};
export const participantApiStatusToParticipantStatus = status => {
  if (!status) {
    throw new Error('empty participant status api');
  }
  const mappedStatus = participantApiStatusToParticipantStatusMap[status];
  if (!mappedStatus) {
    throw new Error(`Unknown participant status api: ${status}`);
  }
  return mappedStatus;
};
export const participantStatusToParticipantApiStatus = status => {
  const mappedStatus = participantStatusToParticipantStatusApisMap[status];
  if (!mappedStatus) {
    throw new Error(`Unknown participant status: ${status}`);
  }
  return mappedStatus;
};
export const participantApiToParticipant = participant => {
  var _participant$detailed, _participant$detailed2;
  if (!participant) {
    throw new Error('Invalid participant');
  }
  const convertedParticipant = {
    id: participant.id,
    revision: participant.revision,
    createdDate: participant.createdDate,
    updatedDate: participant.updatedDate,
    actionId: participant.actionId,
    contactId: participant.contactId,
    status: participantApiStatusToParticipantStatus((_participant$detailed = participant.detailedStatus) == null ? void 0 : _participant$detailed.status),
    notes: (_participant$detailed2 = participant.detailedStatus) == null ? void 0 : _participant$detailed2.notes,
    recurringScheduleId: participant.recurringScheduleId,
    conversationId: participant.conversationId
  };
  if (isValidParticipant(convertedParticipant)) {
    return convertedParticipant;
  }
  throw new Error('Invalid participant data');
};
//# sourceMappingURL=converters.js.map